import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { IIntegrationResponse } from "../../features/Configurations/Integration/interface";

export const useIntegrations = () => {
  return useQuery({
    queryKey: ["integrations"],
    queryFn: async () => {
      const response = await httpService.get<IIntegrationResponse>(
        API_CONFIG.path.connectedAccounts
      );
      return response;
    },
  });
};
